import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Hanghoatonghop from "components/Duongthuy/Hanghoa/Hanghoatonghop.js";
export default function HanghoaTH() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Báo cáo số lượng hàng hóa",
            tabContent: <Hanghoatonghop />,
          },
        ]}
      />
    </div>
  );
}
